module.exports = __webpack_public_path__ + "static/media/SF-Compact-Text-MediumItalic.1ce5f298.otf";